module.exports = __webpack_public_path__ + "img/settings.0892686e.svg";